import { FC } from 'react';
import * as React from 'react';
import 'twin.macro';
import 'styled-components/macro';

export const Card: FC<React.HTMLAttributes<HTMLElement>> = props => <div tw="rounded bg-white" {...props} />;
